/* PXP theme behaviours — vanilla JS, no dependencies. */
(function () {
  "use strict";

  /* ---- Sticky header: overlay -> solid on scroll ---------------------- */
  function initHeader() {
    var header = document.querySelector("[data-header]");
    if (!header) return;
    var overlay = header.hasAttribute("data-overlay");
    function onScroll() {
      var solid = window.scrollY > 40 || !overlay;
      header.classList.toggle("site-header--solid", solid);
      header.classList.toggle("site-header--overlay", overlay && !solid);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Hero slider ----------------------------------------------------- */
  function initHero() {
    var hero = document.querySelector("[data-hero]");
    if (!hero) return;
    var slides = Array.prototype.slice.call(hero.querySelectorAll(".hero__slide"));
    var dots = Array.prototype.slice.call(hero.querySelectorAll(".hero__dot"));
    if (slides.length < 2) return;
    var i = 0;
    var interval = parseInt(hero.getAttribute("data-interval"), 10) || 6000;
    var timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle("is-active", idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle("is-active", idx === i); });
    }
    function next() { go(i + 1); }
    function start() { if (interval > 0) timer = setInterval(next, interval); }
    function stop() { clearInterval(timer); }
    dots.forEach(function (d, idx) {
      d.addEventListener("click", function () { stop(); go(idx); start(); });
    });
    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", start);
    start();
  }

  /* ---- Cart drawer + mobile nav --------------------------------------- */
  function initDrawers() {
    var overlay = document.querySelector("[data-drawer-overlay]");
    function open(el) {
      if (!el) return;
      el.classList.add("is-open");
      if (overlay) overlay.classList.add("is-open");
      document.documentElement.style.overflow = "hidden";
    }
    function closeAll() {
      document.querySelectorAll(".is-open").forEach(function (el) { el.classList.remove("is-open"); });
      document.documentElement.style.overflow = "";
    }
    document.querySelectorAll("[data-open-cart]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); open(document.querySelector("[data-cart-drawer]")); });
    });
    document.querySelectorAll("[data-open-menu]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); open(document.querySelector("[data-mobile-nav]")); });
    });
    document.querySelectorAll("[data-close-drawer]").forEach(function (b) {
      b.addEventListener("click", closeAll);
    });
    if (overlay) overlay.addEventListener("click", closeAll);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  }

  /* ---- Scroll reveal --------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-visible"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Product gallery thumbs ----------------------------------------- */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (g) {
      var main = g.querySelector("[data-gallery-main] img");
      if (!main) return;
      g.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
        t.addEventListener("click", function () {
          var full = t.getAttribute("data-full") || t.querySelector("img").src;
          main.src = full;
        });
      });
    });
  }

  /* ---- Variant swatches (demo behaviour) ------------------------------ */
  function initSwatches() {
    document.querySelectorAll("[data-swatches]").forEach(function (group) {
      group.querySelectorAll(".swatch").forEach(function (s) {
        s.addEventListener("click", function () {
          group.querySelectorAll(".swatch").forEach(function (x) { x.classList.remove("is-selected"); });
          s.classList.add("is-selected");
        });
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    initHeader();
    initHero();
    initDrawers();
    initReveal();
    initGallery();
    initSwatches();
  });
})();
